import { render, staticRenderFns } from "./MaterialUpload.vue?vue&type=template&id=1860531f&"
import script from "./MaterialUpload.vue?vue&type=script&lang=js&"
export * from "./MaterialUpload.vue?vue&type=script&lang=js&"
import style0 from "./MaterialUpload.vue?vue&type=style&index=0&id=1860531f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports